import usePrivateAxios from "@/common/api/usePrivateAxios"
import { CompanyUserData, CompanyUserResponse } from "@/features/privateCompanies/types/companyUsers.type"
import { UseQueryResult, useQuery } from "@tanstack/react-query"

type UseCompanyUserProps = {
  id: string
}

type UseCompanyUserType = ({}: UseCompanyUserProps) => UseQueryResult<CompanyUserData, unknown>

const useCompanyUser: UseCompanyUserType = ({ id }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<CompanyUserResponse, unknown, CompanyUserData>({
    queryKey: ['companyUser', id],
    queryFn: () => {
      return privateAxios.get(`/client/users/${id}`)
    },
    select: (data) => data?.data?.data,
  })
}

export default useCompanyUser
